import React, { useState } from "react";
import { useLanguage } from '../../components/hooks/LanguageContext'; // <-- используем хук
import AppProps from "../../static/js/AppProps"

const ContactForm = () => {
    const { language } = useLanguage(); // глобальный язык
    const [formData, setFormData] = useState({
        username: '',
        email: '',
        message: '',
    });
    const [status, setStatus] = useState(null);
    const [errorMessage, setErrorMessage] = useState('');
    const [isLoading, setIsLoading] = useState(false);

    const handleChange = (e) => {
        setFormData(prev => ({
            ...prev,
            [e.target.name]: e.target.value,
        }));
        setStatus(null);
        setErrorMessage('');
    };

    const validateEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setStatus(null);
        setErrorMessage('');

        if (!formData.username.trim()) {
            setErrorMessage(language === 'ru' ? 'Пожалуйста, введите имя.' : 'Please enter your name.');
            setStatus('error');
            return;
        }
        if (!validateEmail(formData.email)) {
            setErrorMessage(language === 'ru' ? 'Пожалуйста, введите корректный Email.' : 'Please enter a valid email.');
            setStatus('error');
            return;
        }
        if (formData.message && formData.message.trim().length < 5) {
            setErrorMessage(language === 'ru' ? 'Сообщение должно содержать минимум 5 символов.' : 'Message must be at least 5 characters.');
            setStatus('error');
            return;
        }

        const body = { ...formData };
        setIsLoading(true);

        try {
            const response = await fetch(`${AppProps.flask_server_url}/feedback`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(body),
            });

            if (response.ok) {
                setStatus('success');
                setFormData({ username: '', email: '', message: '' });
            } else {
                const text = await response.text();
                setErrorMessage(text || (language === 'ru' ? 'Ошибка при отправке формы' : 'Form submission error'));
                setStatus('error');
            }
        } catch (error) {
            setErrorMessage(language === 'ru' ? 'Ошибка соединения с сервером' : 'Server connection error');
            setStatus('error');
        } finally {
            setIsLoading(false);
        }
    };

    const textContent = {
        ru: {
            title: "Остались вопросы?",
            description: "Оставьте заявку и наш менеджер ответит на все ваши вопросы",
            usernamePlaceholder: "Имя",
            emailPlaceholder: "E-mail",
            messagePlaceholder: "Сообщение",
            promoText: "* Укажите промокод в письме и мы активируем ваш бонус с учетом ваших пожеланий",
            submitButton: "Отправить сообщение",
            sendingButton: "Отправка..."
        },
        en: {
            title: "Got Questions?",
            description: "Submit your enquiry and our manager will respond promptly.",
            usernamePlaceholder: "Name",
            emailPlaceholder: "Email",
            messagePlaceholder: "Message",
            promoText: "* Include your promo code in the message to activate your personalised bonus.",
            submitButton: "Submit your enquiry",
            sendingButton: "Sending..."
        }
    };

    const t = textContent[language];

    return (
        <section data-bs-version="5.1" className="form5 cid-uB6StPuHiB" id="form5-o" style={{ paddingBottom: '50px' }}>
            <div className="container">
                <div className="mbr-section-head text-center">
                    <h3 className="mbr-section-title mbr-fonts-style mb-2 display-2">
                        <strong>{t.title}</strong>
                    </h3>
                    <p className="mbr-fonts-style mb-0 display-7">{t.description}</p>
                </div>

                <div className="row justify-content-center mt-4">
                    <div className="col-lg-8 mx-auto mbr-form" data-form-type="formoid">
                        <form
                            id="contactForm"
                            onSubmit={handleSubmit}
                            className="mbr-form form-with-styler"
                            data-form-title="Form Name"
                            noValidate
                        >
                            <div className="row">
                                {status === 'success' && (
                                    <div className="alert alert-success col-12" role="alert">
                                        {language === 'ru' ? 'Спасибо за заполнение заявки!' : 'Thank you for your enquiry!'}
                                    </div>
                                )}
                                {status === 'error' && (
                                    <div className="alert alert-danger col-12" role="alert">
                                        {errorMessage || (language === 'ru' ? 'Произошла ошибка' : 'An error occurred')}
                                    </div>
                                )}
                            </div>
                            <div className="dragArea row">
                                <div className="col-md col-sm-12 form-group mb-3">
                                    <input
                                        type="text"
                                        name="username"
                                        placeholder={t.usernamePlaceholder}
                                        className="form-control"
                                        value={formData.username}
                                        onChange={handleChange}
                                        required
                                        maxLength={30}
                                        disabled={isLoading}
                                    />
                                </div>
                                <div className="col-md col-sm-12 form-group mb-3">
                                    <input
                                        type="email"
                                        name="email"
                                        placeholder={t.emailPlaceholder}
                                        className="form-control"
                                        value={formData.email}
                                        onChange={handleChange}
                                        required
                                        maxLength={50}
                                        disabled={isLoading}
                                    />
                                </div>
                                <div className="col-12 form-group mb-3">
                                    <textarea
                                        name="message"
                                        placeholder={t.messagePlaceholder}
                                        className="form-control"
                                        value={formData.message}
                                        onChange={handleChange}
                                        rows={4}
                                        disabled={isLoading}
                                    />
                                </div>
                                <p className="text-center mt-3" style={{ fontSize: '0.9rem', color: '#6c757d' }}>
                                    {t.promoText}
                                </p>
                                <div className="col-lg-12 col-md-12 col-sm-12 align-center mbr-section-btn">
                                    <button type="submit" className="btn btn-info display-4" disabled={isLoading}>
                                        {isLoading ? t.sendingButton : t.submitButton}
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default ContactForm;
